import { motion } from "framer-motion";
import { Zap, ShieldCheck, Clock, MessageCircle, Star } from "lucide-react";
import { fadeInUp, staggerContainer } from "../data/constants";

export const FeaturesSection = () => {
  const features = [
    {
      icon: Zap,
      title: "Alta Velocidad",
      description: "Conexión de fibra óptica que garantiza la máxima velocidad para todas tus actividades.",
    },
    {
      icon: ShieldCheck,
      title: "Conexión Estable",
      description: "99.9% de uptime garantizado. Tu conexión siempre disponible cuando la necesites.",
    },
    {
      icon: Clock,
      title: "Fácil Contratación",
      description: "Proceso simple y rápido. Instalación en máximo 10 días hábiles después de la firma.",
    },
    {
      icon: MessageCircle,
      title: "Soporte Dedicado",
      description: "Equipo de asesores disponible para resolver todas tus dudas y necesidades.",
    },
  ];

  return (
    <section className="py-24 bg-white" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
          >
            <motion.span
              variants={fadeInUp}
              className="text-orange-500 font-semibold uppercase tracking-wider"
            >
              ¿Por qué elegirnos?
            </motion.span>
            <motion.h2
              variants={fadeInUp}
              className="text-4xl md:text-5xl font-bold text-gray-900 mt-4 mb-6"
            >
              "Justo lo que necesitas,{" "}
              <span className="text-orange-500">más de lo que esperas</span>"
            </motion.h2>
            <motion.p variants={fadeInUp} className="text-xl text-gray-600 mb-8">
              Somos una empresa de tecnología e innovación comprometida con brindarte 
              la mejor experiencia de conexión a internet.
            </motion.p>

            <motion.div variants={staggerContainer} className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <motion.div
                    key={index}
                    variants={fadeInUp}
                    className="p-6 rounded-2xl bg-gray-50 hover:bg-orange-50 transition-colors"
                  >
                    <div className="feature-icon mb-4">
                      <Icon className="w-6 h-6" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </motion.div>
                );
              })}
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative">
              <img
                src="/images/team-photo-1.jpg"
                alt="Equipo de trabajo Flowing"
                className="rounded-3xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                    <Star className="w-6 h-6 text-orange-500" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">5+ años</div>
                    <div className="text-gray-500">de experiencia</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
